export default __webpack_public_path__ + "static/media/olesen.a8f33411.jpeg";